import React from 'react';
import { Template } from '../../../../../redux/features/doctor/Dashboard/templates/templates';
import { useAppSelector } from '../../../../../redux/hooks';
import { useTranslation } from 'react-i18next';
import { Box, Typography, Divider } from '@mui/material';

interface TemplatePreviewProps {
  template: Template | null;
}

const TemplatePreview: React.FC<TemplatePreviewProps> = ({ template }) => {
  const { t } = useTranslation();
  const colors = useAppSelector((state) => state.theme.colors);

  if (!template) {
    return null;
  }

  return (
    <Box>
      {/* FIX: Using the correct theme color 'listInfo' for the preview title. */}
      <Typography variant="h6" gutterBottom sx={{ color: colors?.listInfo }}>
        {t('livePreview')}
      </Typography>
      <Typography variant="h4" component="h2" gutterBottom sx={{ fontWeight: 'bold', color: colors?.text }}>
        {template.title}
      </Typography>
      <Divider sx={{ my: 2, borderColor: colors?.folderDataRowBorderColor }} />
      {template.sections.map((section, index) => (
        <Box key={index} sx={{ mb: 3 }}>
          {/* FIX: Using the correct theme color 'listInfo' for the section titles. */}
          <Typography variant="h6" component="h3" sx={{ textTransform: 'uppercase', fontWeight: 'bold', letterSpacing: '1px', color: colors?.listInfo, fontSize: '0.9rem' }}>
            {section.title}
          </Typography>
          <Typography variant="body1" sx={{ whiteSpace: 'pre-wrap', mt: 1, color: colors?.text, lineHeight: 1.6 }}>
            {section.exampleText}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};

export default TemplatePreview;